export const INTRANET_PAGE_CONTAINER_SX = {
  mt: 5,
  paddingBottom: 3,
  mb: 3,
};

export const INTRANET_FORM_CARD_SX = {
  p: 3,
  maxWidth: 800,
  mx: 'auto',
};

export const INTRANET_FORM_GRID_SX = {
  display: 'grid',
  gap: 2,
  gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
  maxWidth: 750,
  mx: 'auto',
};

export const INTRANET_FULL_WIDTH_FIELD_SX = {
  gridColumn: { xs: '1 / -1', sm: 'span 1' },
};

export const INTRANET_WIDE_FIELD_SX = {
  gridColumn: '1 / -1',
};
